import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Form, Row, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { PencilIcon } from '@primer/octicons-react'
import { BiUnlink } from "react-icons/bi";
import  DeleteConfirmDialog  from './DeleteConfirmDialog';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_BLDG_DATA_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';
import { formatFileSize } from '../utils/jsUtils';


const DocAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
    id: '',
    name: '',
    displayname: '',
    path: '',
    description: '',
    cartegory: '',
    tags: '',
    fileType: '',
    fileExt: '',
    size: '',
    updatedBy: '',
    timeUpdated: '',
    createdBy: '',
    timeCreated: ''
  });

  const [currentObjAttrs,          setCurrentObjAttrs]         = useState([]);

  const [imageDoc,                 setImageDoc]                = useState();

  const [linkedAssetList,          setLinkedAssetList]         = useState([]);
  const [linkedPhotoList,          setLinkedPhotoList]         = useState([]);

  const [assetUnlinkTarget,        setAssetUnlinkTarget]       = useState();
  const [showAssetUnlinkCfmDlg,    setShowAssetUnlinkCfmDlg]   = useState(false);
  const [errMsgAssetUnlinkCfmDlg,  setErrMsgAssetUnlinkCfmDlg] = useState('')

  const [photoUnlinkTarget,        setPhotoUnlinkTarget]       = useState();
  const [showPhotoUnlinkCfmDlg,    setShowPhotoUnlinkCfmDlg]   = useState(false);
  const [errMsgPhotoUnlinkCfmDlg,  setErrMsgPhotoUnlinkCfmDlg] = useState('')


  // Initialize state
  useEffect(() => {

    if (props) {
      fetchObj(props.objDetails.id);

      fetchLinkedAssets(props.objDetails.id);
      fetchLinkedPhotos(props.objDetails.id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const fetchObj = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("docs/" + id);

        resolve(res.data);

        if (res.status === 200) {
          setObjAttrs(res.data[0]);
          setCurrentObjAttrs(res.data[0]);

          // Fetch image if the doc type is image, so can show in the thumbnail.
          // ##### Exclude SVG image for now, until we can find a way to properly display it #####
          if (res.data[0].fileType.startsWith('image') && (res.data[0].fileType.indexOf('svg+xml') < 0)) {
            fetchImage(res.data[0].path, res.data[0].fileTyle);
          }
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const fetchImage = (path, fileType) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_BLDG_DATA_API.get(`/files?path=${encodeURIComponent(path)}`, {
                                                        responseType: "arraybuffer",
                                                      });

        resolve(res.data);

        if (res.status === 200) {

          // Convert HEX data to binary
          const blob = new Blob([new Uint8Array(res.data)], { type: fileType });
          const blobUrl = URL.createObjectURL(blob);

          setImageDoc(blobUrl);
        }

        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);

  const [errMsg, setErrMsg] = useState('');

  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }


  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

/*
  const onStatusSelect = (key, event) => {
    setObjAttrs({ ...objAttrs, status: key })
  };
*/


  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setObjAttrs(currentObjAttrs);

    setEditMode(false);
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    // Validate form inputs
    if (objAttrs.displayName.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_display_name"));
      return;
    } else if (objAttrs.displayName.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_display_name") + 250);
      return;
    } else if (objAttrs.description.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 250);
      return;
    } else if (objAttrs.category.length > 20) {
      setErrMsg(t("I18N_ERR_Max_len_cat") + 20);
      return;
    } else if (objAttrs.tags.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_tags") + 250);
      return;
    }

    // Deep copy
    let tmpAttrs = JSON.parse(JSON.stringify(objAttrs));

    const reqBody = tmpAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.put("docs/" + objAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setEditMode(false);

          fetchObj(objAttrs.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }

  const handleDownload = (e) => {
    e.preventDefault();

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_BLDG_DATA_API.get(`/files?path=${encodeURIComponent(objAttrs.path)}`, {
                                                        responseType: "arraybuffer",
                                                      });

        resolve(res.data);

        if (res.status === 200) {

          // Convert HEX data to binary
          const blob = new Blob([new Uint8Array(res.data)], { type: objAttrs.fileType });
          const blobUrl = URL.createObjectURL(blob);

          const nameSplit = objAttrs.path.split("/");
          const fileName = nameSplit.pop();

          const link = document.createElement('a')

          link.href = blobUrl;
          link.download = "" + fileName + "";
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST');
  }



  // --- Linked Asset Stuff ---

  const fetchLinkedAssets = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("docs/" + id + "/assets");

        resolve(res.data);

        if (res.status === 200) {

          setLinkedAssetList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  function renderLinkedAsset(asset, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>{asset.code}</td>
        <td>{asset.name}</td>
        <td>
          <OverlayTrigger overlay={<Tooltip id="tooltip-unlink-asset" style={{fontSize:'11px'}}>{t("I18N_TIP_Unlink_asset")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleAssetUnlink(asset)}><BiUnlink size={12} /></span>
          </OverlayTrigger>
        </td>
      </tr>
    )
  }

  function handleAssetUnlink(asset) {
    setAssetUnlinkTarget(asset);
    setShowAssetUnlinkCfmDlg(true);
  }

  function handleAssetUnlinkCancel() {
    setAssetUnlinkTarget(null);
    setErrMsgAssetUnlinkCfmDlg('');
    setShowAssetUnlinkCfmDlg(false);
  }

  function handleAssetUnlinkSubmit() {

    let reqBody = {
          docIdList: [objAttrs.id]
        };

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.delete("assets/" + assetUnlinkTarget.id + "/docs", {data: reqBody});

        resolve(res.data);

        if (res.status === 200) {

          fetchLinkedAssets(objAttrs.id);

          setErrMsgAssetUnlinkCfmDlg('');
          setShowAssetUnlinkCfmDlg(false);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsgAssetUnlinkCfmDlg(t(translateAPIError(error)));
        }
      }
    });
  }


  // --- Linked Asset Photo Stuff ---

  const fetchLinkedPhotos = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("assets?photoId=" + id);

        resolve(res.data);

        if (res.status === 200) {

          setLinkedPhotoList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  function renderLinkedPhoto(asset, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>{asset.code}</td>
        <td>{asset.name}</td>
        <td>
          <OverlayTrigger overlay={<Tooltip id="tooltip-unlink-asset" style={{fontSize:'11px'}}>{t("I18N_TIP_Unlink_asset_photo")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handlePhotoUnlink(asset)}><BiUnlink size={12} /></span>
          </OverlayTrigger>
        </td>
      </tr>
    )
  }

  function handlePhotoUnlink(asset) {
    setPhotoUnlinkTarget(asset);
    setShowPhotoUnlinkCfmDlg(true);
  }

  function handlePhotoUnlinkCancel() {
    setPhotoUnlinkTarget(null);
    setErrMsgPhotoUnlinkCfmDlg('');
    setShowPhotoUnlinkCfmDlg(false);
  }

  function handlePhotoUnlinkSubmit() {

    let reqBody = {
          photoId: null
        };

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.patch("assets/" + photoUnlinkTarget.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          fetchLinkedPhotos(objAttrs.id);

          setErrMsgPhotoUnlinkCfmDlg('');
          setShowPhotoUnlinkCfmDlg(false);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsgPhotoUnlinkCfmDlg(t(translateAPIError(error)));
        }
      }
    });
  }



  // ----- BEGIN UI -----

  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_Doc_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Doc_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Name")}:</Col>
                  <Col>{t("I18N_Display_name")}: *</Col>
                  <Col>{t("I18N_Description")}:</Col>
                  <Col>{t("I18N_Path")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>{objAttrs.name}</Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="displayName" value={objAttrs.displayName}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px', backgroundColor:'white'}}
                              name="description" value={objAttrs.description}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>{objAttrs.path}</Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Category")}:</Col>
                  <Col>{t("I18N_File_type")}:</Col>
                  <Col>{t("I18N_File_ext")}:</Col>
                  <Col>{t("I18N_Size")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
		  <Col>
		    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="category" value={objAttrs.category}
		      onChange={(e) => onAttrsInputChange(e)} />
		  </Col>
                  <Col>{objAttrs.fileType}</Col>
                  <Col>{objAttrs.fileExt}</Col>
                  <Col>{formatFileSize(objAttrs.size)}</Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Tags")}:</Col>
                  <Col></Col>
                  <Col></Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
		  <Col>
		    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="tags" value={objAttrs.tags}
		      onChange={(e) => onAttrsInputChange(e)} />
		  </Col>
                  <Col></Col>
                  <Col></Col>
                  <Col></Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Name")}:</Col>
                <Col>{t("I18N_Display_name")}:</Col>
                <Col>{t("I18N_Description")}:</Col>
                <Col>{t("I18N_Path")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{objAttrs.name}</Col>
                <Col>{objAttrs.displayName}</Col>
                <Col style={{maxHeight:'120px', overflow:'auto', flexWrap:'wrap', wordWrap:'break-word'}}>
                  {objAttrs.description}
                </Col>
                <Col>{objAttrs.path}</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Category")}:</Col>
                <Col>{t("I18N_File_type")}:</Col>
                <Col>{t("I18N_File_ext")}:</Col>
                <Col>{t("I18N_Size")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{objAttrs.category}</Col>
                <Col>{objAttrs.fileType}</Col>
                <Col>{objAttrs.fileExt}</Col>
                <Col>{formatFileSize(objAttrs.size)}</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                { imageDoc ?
                <Col>{t("I18N_Thumbnail")}:</Col>
                : null }
                <Col>{t("I18N_Tags")}:</Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                { imageDoc ?
                <Col>
                  <img src={imageDoc} alt="AAA" style={{marginTop:'5px', maxWidth:'150px', maxHeight:'150px'}} />
                </Col>
                : null }
                <Col>{objAttrs.tags}</Col>
                <Col></Col>
                <Col></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{objAttrs.creatorUsername}</Col>
                <Col>{formatDate(objAttrs.timeCreated)}</Col>
                <Col>{objAttrs.updaterUsername}</Col>
                <Col>{formatDate(objAttrs.timeUpdated)}</Col>
              </Row>
            </Container>
          }
        </div>


        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'30px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_Linked_assets")}
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>

            <Table hover responsive size="sm">
              <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                <tr>
                  <th style={{width:'25%', fontWeight:'400'}}>{t("I18N_Asset_code")}</th>
                  <th style={{width:'50%', fontWeight:'400'}}>{t("I18N_Name")}</th>
                  <th style={{width:'5%'}}></th>
                </tr>
              </thead>
              <tbody>
                {linkedAssetList.map(renderLinkedAsset)}
              </tbody>
            </Table>
          </div>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'10px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_Used_as_cover_photo")}
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>

            <Table hover responsive size="sm">
              <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                <tr>
                  <th style={{width:'25%', fontWeight:'400'}}>{t("I18N_Asset_code")}</th>
                  <th style={{width:'50%', fontWeight:'400'}}>{t("I18N_Name")}</th>
                  <th style={{width:'5%'}}></th>
                </tr>
              </thead>
              <tbody>
                {linkedPhotoList.map(renderLinkedPhoto)}
              </tbody>
            </Table>
          </div>
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleDownload}>
                {t("I18N_Download")}
              </Button>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '10px', fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </div>
{/*
            <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
              {updateObjErrMsg}
            </span>
*/}
          </Form.Group>
        </div>


        <DeleteConfirmDialog
          title={("I18N_Unlink_asset_confirm")}
          show={showAssetUnlinkCfmDlg}
          targetName={assetUnlinkTarget ? assetUnlinkTarget.name : ''}
          errMsgDeleteConfirm={errMsgAssetUnlinkCfmDlg}
          onCancel={handleAssetUnlinkCancel}
          onSubmit={handleAssetUnlinkSubmit}
        />


        <DeleteConfirmDialog
          title={t("I18N_Unlink_cover_photo_confirm")}
          show={showPhotoUnlinkCfmDlg}
          targetName={photoUnlinkTarget ? photoUnlinkTarget.name : ''}
          errMsgDeleteConfirm={errMsgPhotoUnlinkCfmDlg}
          onCancel={handlePhotoUnlinkCancel}
          onSubmit={handlePhotoUnlinkSubmit}
        />


      </Card>
    </>
  );
}

export default DocAdminDetailsView;
